/* eslint-disable no-undef */

'use strict';

var baseRequest = {
    apiVersion: 2,
    apiVersionMinor: 0
};

var gatewayMerchantId = $('#googlePaygatewayMerchantId').val();

var googleMerchantId = $('#googlePayMerchantID').val();

var googlePayEnvironment = $('#googlePayEnvironment').val();

var allowedCardNetworks = ['AMEX', 'DISCOVER', 'JCB', 'MASTERCARD', 'VISA'];

var allowedCardAuthMethods = ['PAN_ONLY', 'CRYPTOGRAM_3DS'];

var tokenizationSpecification = {
    type: 'PAYMENT_GATEWAY',
    parameters: {
        gateway: 'cybersource',
        gatewayMerchantId: gatewayMerchantId
    }
};

const baseUrl = window.location.origin;

var baseCardPaymentMethod = {
    type: 'CARD',
    parameters: {
        allowedAuthMethods: allowedCardAuthMethods,
        allowedCardNetworks: allowedCardNetworks,
        billingAddressRequired: true,
        billingAddressParameters: {
            format: 'FULL',
            phoneNumberRequired: true
        }
    }
};

var cardPaymentMethod = {
    tokenizationSpecification: tokenizationSpecification,
    ...baseCardPaymentMethod
};
var paymentsClient = null;

/**
 * @returns {*} *
 */
function getGoogleIsReadyToPayRequest() {
    return {
        ...baseRequest,
        allowedPaymentMethods: [baseCardPaymentMethod]
    };
}

/**
 * *
 * @returns {*} *
 */
function getGooglePaymentDataRequest() {
    var paymentDataRequest = {
        ...baseRequest
    };
    paymentDataRequest.allowedPaymentMethods = [cardPaymentMethod];
    paymentDataRequest.transactionInfo = getGoogleTransactionInfo();
    paymentDataRequest.emailRequired = true;
    paymentDataRequest.shippingAddressRequired = true;
    paymentDataRequest.shippingAddressParameters = {
        phoneNumberRequired: true
    },
        paymentDataRequest.merchantInfo = {
            merchantId: googleMerchantId
        };
    return paymentDataRequest;
}

/**
 * *
 * @returns {*} *
 */
function getGooglePaymentsClient() {
    if (paymentsClient === null) {
        if (googlePayEnvironment === 'TEST') {
            paymentsClient = new google.payments.api.PaymentsClient({ // eslint-disable-line no-undef
                environment: 'TEST'
            });
        } else {
            paymentsClient = new google.payments.api.PaymentsClient({ // eslint-disable-line no-undef
                environment: 'PRODUCTION',
                merchantInfo: {
                    merchantId: googleMerchantId
                }
            });
        }
    }
    return paymentsClient;
}

/**
 */
function onGooglePayLoaded() {
    // eslint-disable-next-line no-shadow
    var paymentsClient = getGooglePaymentsClient();
    paymentsClient.isReadyToPay(getGoogleIsReadyToPayRequest())
        .then(function (response) {
            if (response.result) {
                addGooglePayButton();
                prefetchGooglePaymentData();
            } else {
                var popupHeader = 'Alert!!';
                var popupBody = 'Unable to pay using Google Pay';
                var popupTemplate = '<div class="modal fade">'
                    + '<div class="modal-dialog">'
                    + '<div class="modal-content">'
                    + '<div class="modal-header">'
                    + '<h4 class="modal-title">' + popupHeader + '</h4>'
                    + '</div>'
                    + '<div class="modal-body">'
                    + '<div class="row">'
                    + '<div class="col">'
                    + '<h5>' + popupBody + '</h5>'
                    + '</div>'
                    + '</div>'
                    + '</div>'
                    + '    <div class="modal-footer">'
                    + '        <div class="row">'
                    + '            <div class="col">'
                    + '            </div>'
                    + '            <div class="col">'
                    + '            </div>'
                    + '         </div>'
                    + '      </div>'
                    + '    </div>'
                    + '  </div>'
                    + '</div>';
                $(popupTemplate).modal();
            }
        });
}

/**
 */
function addGooglePayButton() {
    // eslint-disable-next-line no-shadow
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    // Show only for Safari — hide for all others
    if (!isSafari) {
        $('#applepay-content').addClass('d-none');
    }

    var paymentsClient = getGooglePaymentsClient();
    var button = paymentsClient.createButton({
        buttonColor: 'default',
        buttonType: 'checkout',
        buttonRadius: 4,
        onClick: onGooglePaymentButtonClicked
    });
    if ($('#js-googlepay-container').length > 0) {
        document.getElementById('js-googlepay-container').appendChild(button);
    }
}

/**
 * @returns {*} *
 */
function getGoogleTransactionInfo() {
    return {
        countryCode: 'US',
        currencyCode: 'USD',
        totalPriceStatus: 'FINAL',
        totalPrice: $('body').find('.row.grand-total').find('.grand-total-sum').text()
            .replace('$', '').replace(',', '')
    };
}

/**
 */
function prefetchGooglePaymentData() {
    var paymentDataRequest = getGooglePaymentDataRequest();
    paymentDataRequest.transactionInfo = {
        totalPriceStatus: 'NOT_CURRENTLY_KNOWN',
        currencyCode: 'USD'
    };
    // eslint-disable-next-line no-shadow
    var paymentsClient = getGooglePaymentsClient();
    paymentsClient.prefetchPaymentData(paymentDataRequest);
}

/**
 */
var paymentDataUpdate;
function onGooglePaymentButtonClicked() {
    $("#maf-close-donation").addClass("d-none")
    var paymentDataRequest = getGooglePaymentDataRequest();
    paymentDataRequest.transactionInfo = getGoogleTransactionInfo();
    // eslint-disable-next-line no-shadow
    var paymentsClient = getGooglePaymentsClient();
    paymentsClient.loadPaymentData(paymentDataRequest)
        .then(function (paymentData) {
            // handle the response
            // processPayment(paymentData);
            paymentDataUpdate = paymentData;
            var checkIfCA = paymentData.paymentMethodData.info.billingAddress.administrativeArea === 'CA' || paymentData.paymentMethodData.info.billingAddress.administrativeArea === 'CALIFORNIA';
            var hasProtectionPlan = $('#hasProtectionPlan').val() === 'true';
            if (hasProtectionPlan && checkIfCA) {
                $("#autoRenewalInput").val("true");
                $("#final-checkout-modal").modal('hide').data('bs.modal', null);
                $('#final-checkout-modal').modal({
                    backdrop: "static",
                    keyboard: false,
                    show: true
                });
            } else if (hasProtectionPlan) {
                processPayment(paymentData, true);
            } else {
                processPayment(paymentData, null);
            }
        });
}

/**
 * @param {*} paymentData *
 */
function processPayment(paymentData, isEnrollAutoRenewal) {
    showModalTransactionInProgress();
    var postdataUrl = window.googlepayval.sessionCallBack;
    var urlParams = {
        paymentData: JSON.stringify(paymentData)

    };
    $.ajax({
        url: postdataUrl,
        type: 'post',
        dataType: 'json',
        data: urlParams,
        success: function (data) {
            if (data.status === 'success') {
                // $('.next-step-button .place-order').removeClass('disabled').trigger('click');
                callOrderSubmit(isEnrollAutoRenewal)
                // window.location.href = window.googlepayval.submitURL + '?isEnrollAutoRenewal=' + isEnrollAutoRenewal;
            } else {
                $("#maf-close-donation").removeClass("d-none")
                window.location.href = window.googlepayval.cartURL;
            }
        }
        
    });
}

function callOrderSubmit(isEnrollAutoRenewal) {
    var endpoint = baseUrl + "/on/demandware.store/Sites-medicalert-Site/default/Checkout-SubmitOrderGPay";

    var queryParams = $.param({
        isEnrollAutoRenewal: isEnrollAutoRenewal
    });

    $.ajax({
    url: endpoint + '?' + queryParams,
    method: "GET",
    dataType: "json",
    success: function (data) {
        if (data.success && data.guestCheckout) {
            window.location.href = baseUrl + "/on/demandware.store/Sites-medicalert-Site/default/COPlaceOrder-Confirmation?order_id=" + data.orderID + "&autoOpt=" + isEnrollAutoRenewal;
        } else if (data.success && data.redirect) {
            window.location.href = data.url + '&isEnrollAutoRenewal=' + isEnrollAutoRenewal;
        } else {
            window.location.href = window.googlepayval.cartURL;
        }
    },
    error: function (error) {
        $("#maf-close-donation").removeClass("d-none")
        console.error("Error submitting order:", error);
    }
});



}


function callOrderConfirmationPage(orderID, orderToken) {
    var endpoint = baseUrl + "/on/demandware.store/Sites-medicalert-Site/default/Order-Confirm";

    var queryParams = $.param({
        orderID: orderID,
        token: orderToken
    });
    $.ajax({
        url: endpoint + '?' + queryParams,
        method: "GET",
        dataType: "json",
        success: function (data) {
            $("#maf-close-donation").removeClass("d-none")
            $('.dontationPayment-Container').addClass("d-none");
            $('#donationFormGuestCheckout').addClass("d-none");
			$('.donationConfirmation-Container').removeClass("d-none");
            $("#donationPaymentBtn")?.prop("disabled", false)
            $("#donationPaymentBtn")?.prop('disabled', true).text("Donate");
			
            // ---------- Donation Type ----------
			if (data.order?.items?.items?.[0]?.productName === "Recurring Donation") {
				$('#donation-confirmation-type').text("Recurring");
			} else if (data.order?.items?.items?.[0]?.productName === "Donation") {
				$('#donation-confirmation-type').text("One Time");
			}

            // ---------- Donation Type ----------
					if (data.order?.items?.items?.[0]?.productName=== "Recurring Donation") {
						$('#donation-confirmation-type').text("Recurring");
                        // for print
						$('#donation-confirmation-type-print').text("Recurring");

					} else if (data.order?.items?.items?.[0]?.productName=== "Donation") {
						$('#donation-confirmation-type').text("One Time");
                        // for print
						$('#donation-confirmation-type-print').text("One Time");

					}

                    let orderNumber = data.order.orderNumber || '';
                    $('#donation-order-number').text(`${orderNumber}`);
                    
            // ---------- Total Amount ----------
            let amount = data.order.billing.payment.selectedPaymentInstruments[0].amount || '';
            const formattedAmount = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD'
            }).format(amount);

            $('#donation-confirmation-amount').text(formattedAmount);
            $('#donation-confirmation-amount-total').text(formattedAmount);

            // ---------- Email ----------
            $('#Confirmation-user-email').text(
                data.order?.orderEmail ? `${data.order.orderEmail}` : ''
            );
            $('#Confirmation-user-phn').text(
                data.order?.billing?.billingAddress?.address?.phone ? `${data.order?.billing?.billingAddress?.address?.phone}` : ''
            );

            $('#Confirmation-user-memberId').text(
				data.memberId ? `Member ID: ${data.memberId}` : ''
			);

            // ---------- Name ----------
            let addr = data.order?.billing?.billingAddress?.address;
            let fullName = addr
                ? `${addr.firstName || ''} ${addr.lastName || ''}`.trim()
                : '';
            let firstName = addr
                ? addr.firstName.trim()
                : '';

            $('#Confirmation-user-Name').text(firstName ? `${firstName}` : '');
            $('#Confirmation-user-Name2').text(fullName ? `${fullName}` : '');

            // ---------- Product Type (NEW) ----------
            let productType = data.order.items.items?.[0]?.productType || '';

            $('#Confirmation-product-type').text(
                productType ? `Product Type: ${productType}` : ''
            );

            // ---------- Payment Method ----------
            let paymentInstrument =
                data.order?.billing?.payment?.selectedPaymentInstruments?.[0];

            let paymentMethod = data.order.billing.payment.selectedPaymentInstruments[0].type || '';

            let cardDisplay =
                data.cardDisplay || paymentInstrument?.maskedCreditCardNumber || '';

            let paymentText = paymentMethod;

            if (paymentMethod) {
						const targetId = `payment-method-${paymentMethod.toLowerCase()}`;
						const el = document.getElementById(targetId);
						if (el) {
                            $('#payment-method-visa,#payment-method-mastercard,#payment-method-amex,#payment-method-discover').addClass("d-none");
							el.classList.remove("d-none");
						}
					}

            if (cardDisplay) {
                paymentText = cardDisplay;
            }

            $('#Payment-method-used').text(paymentText);



            $('#Payment-method-used2').text(paymentText);
                    
                    // For print donation confirmation
                    
                    $('#invoice-number-print').text(`${orderNumber}`);
                    if(data.memberId==null){
                        $("#memberIdPrintContainer").addClass('d-none');
                    }
                    else{
                         $("#memberIdPrintContainer").removeClass('d-none');
                        $('#member-id-print').text(`${data.memberId}`);

                    }

                    if (paymentMethod) {
						const targetId = `payment-method-${paymentMethod.toLowerCase()}-print`;
						const el = document.getElementById(targetId);
						if (el) {
                            $('#payment-method-visa-print, #payment-method-mastercard-print, #payment-method-amex-print, #payment-method-discover-print').addClass("d-none");
							el.classList.remove("d-none");
						}
					}
                    $('#Payment-method-used-print').text(paymentText);
					$('#donation-confirmation-amount-total-print').text(formattedAmount);
					$('#donation-confirmation-amount-total-print2').text(formattedAmount);
					$('#donation-confirmation-amount-total-print3').text(formattedAmount);
					$('#donation-confirmation-amount-total-print4').text(formattedAmount);

                    // For print donation confirmation - Billing address
                    const lastName    = addr?.lastName?.trim() || '';
                    const address1    = addr?.address1?.trim() || '';
                    const address2    = addr?.address2?.trim() || '';
                    const city        = addr?.city?.trim() || '';
                    const stateCode   = addr?.stateCode?.trim() || '';
                    const countryName = addr?.countryCode?.displayValue?.trim() || '';
                    const postalCode  = addr?.postalCode?.trim() || '';
                    const phone       = addr?.phone?.trim() || '';
                    
                    $('#first-name-print').text(firstName);
                    $('#last-name-print').text(lastName);
                    $('#address1-print').text(address1);
                    $('#city-print').text(city + ',');
                    $('#state-print').text(stateCode + ',');
                    $('#country-print').text(countryName + ',');
                    $('#postalcode-print').text(postalCode);
                    $('#phone-print').text(phone);

                    return;


        },
        error: function (err) {
            $("#maf-close-donation").removeClass("d-none")
            console.error("Error:", err);
        }
    });
}

var clickedOnce = false;
if ($('#isGooglePayEnabled').val() === 'true' && $('#gPayPaymentMethodEnabled').val() === 'true') {
    // $('.googlepay-tab-wrapper').click(function () {
    //     if (!clickedOnce) {
    onGooglePayLoaded();
    //         clickedOnce = true;
    //     }
    // });
}


$("#enrollAutorenewal").on("click", function (clickEvent) {
    if (paymentDataUpdate) {
        var $checkbox = $("#checkoutAgree");
        var $agreeError = $(".agree-text-error");

        // Check if checkbox is agreed for enrollment
        if (!$checkbox.is(":checked")) {
            // show error and don't continue
            $agreeError.show();
            return;
        } else {
            $agreeError.hide();
        }
        $("#autoRenewalInput").val("true");
        // Set hidden input to true for auto renewal
        processPayment(paymentDataUpdate, true);
        $("#final-checkout-modal").modal("hide");
    }
})

$("#noEnrollAutorenewal").on("click", function (clickEvent) {
    if (paymentDataUpdate) {
        processPayment(paymentDataUpdate, false);
        $("#autoRenewalInput").val("false");
        $("#final-checkout-modal").modal("hide");
    }
})

function showModalTransactionInProgress() {
    var loaderURL = $('#loaderImage').val();
    $(".Billingwizardloader").show();
    $("#donationPaymentBtn")?.prop("disabled", true)
    $("#donationPaymentBtn")?.prop('disabled', true).html(`
        <span class="loaderForWizard">
            <img class="loaderForWizardImage" src="${loaderURL}" alt="credit-card-image" />
        </span>
    `);
}

